import { Skeleton } from "@/components/ui/skeleton";

export function MyGameCardSkeleton() {
  return (
    <div className="horizontal-entity-card pointer-events-none">
      <div className="horizontal-entity-card__image">
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent" />
        <Skeleton className="absolute top-4 right-4 h-6 w-24 rounded-full" />
        <Skeleton className="absolute bottom-4 left-4 right-4 h-6 rounded-md" />
      </div>

      <div className="flex flex-1 flex-col md:flex-row">
        <div className="flex-1 p-5 md:p-6 flex flex-col justify-center gap-4">
          <Skeleton className="h-5 w-40" />
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <Skeleton className="w-5 h-5 rounded-full" />
              <Skeleton className="h-4 w-32" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="w-5 h-5 rounded-full" />
              <Skeleton className="h-4 w-56" />
            </div>
          </div>
          <div className="mt-1 pt-3 border-t border-border">
            <div className="flex justify-between items-center mb-2">
              <Skeleton className="h-3 w-32" />
              <Skeleton className="h-3 w-20" />
            </div>
            <Skeleton className="h-2.5 w-full rounded-full" />
          </div>
        </div>

        <div className="horizontal-entity-card__sidebar">
          <Skeleton className="h-12 w-full rounded-xl" />
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}
